import { useState } from 'react';
import { Menu, X } from 'lucide-react';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import IntegrationsSection from './components/IntegrationsSection';
import PricingTeaserSection from './components/PricingTeaserSection';
import ComparisonSection from './components/ComparisonSection';
import ScreenshotsSection from './components/ScreenshotsSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import './styles/LandingPage.css';
import crestaLogo from '/assets/brand/cresta-logo.png';

/**
 * LandingPage Component
 * 
 * Main landing page for Cresta SaaS platform.
 * Showcases features, screenshots, and provides access to demo and login.
 */
function LandingPage() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
    const closeMenu = () => setIsMenuOpen(false);

    // Development check
    console.log('[Cresta] Env Check:', { 
        env_loaded: true
    });

    return (
        <div className={`landing-page ${isMenuOpen ? 'menu-open' : ''}`}>
            <nav className="landing-nav">
                <div className="nav-container">
                    <div className="nav-logo">
                        <img
                            src={crestaLogo}
                            alt="Cresta Logo"
                            className="logo-image"
                        />
                    </div>

                    {/* Desktop Links */}
                    <div className="nav-links desktop-only">
                        <a href="#features" className="nav-link">Características</a>
                        <a href="#integrations" className="nav-link">Integraciones</a>
                        <a href="#screenshots" className="nav-link">Galería</a>
                    </div>

                    {/* Mobile Menu Toggle */}
                    <button
                        id="hamburger"
                        className="mobile-menu-toggle"
                        onClick={toggleMenu}
                        aria-label="Toggle menu"
                    >
                        {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
                    </button>
                </div>

                {/* Mobile Menu Overlay */}
                <div className={`mobile-menu ${isMenuOpen ? 'active' : ''}`}>
                    <div className="mobile-menu-content">
                        <a href="#features" className="mobile-nav-link" onClick={closeMenu}>Características</a>
                        <a href="#integrations" className="mobile-nav-link" onClick={closeMenu}>Integraciones</a>
                        <a href="#screenshots" className="mobile-nav-link" onClick={closeMenu}>Galería</a>
                    </div>
                </div>
            </nav>

            <HeroSection />
            <IntegrationsSection />
            <FeaturesSection />
            <PricingTeaserSection />
            <ComparisonSection />
            <ScreenshotsSection />
            <CTASection />
            <Footer />
        </div>
    );
}

export default LandingPage;
